export const query_aziende_byTenant = `
query getAziendeByTenant($tenantId: String!) {
  azienda(where: {
    TenantId: {_eq: $tenantId}
  }, order_by: {Denominazione: asc}) {
    Id
    Denominazione
    Cf
    PIva
    AddrPaeseId
    AddrProvinciaId
    AddrProvincia
    AddrComuneId
    AddrComune
    AddrIndirizzo
    AddrN
    AddrCap
    CreatedOn
    ModifiedOn
    CreatedBy
    ModifiedBy
    MeteringSlotId
  }
}`;
export const query_aziende_byId = `
query getAziendeByTenant($id: Int!) {
  azienda_by_pk(Id: $id) {
    Id
    TenantId
    Denominazione
    Cf
    PIva
    AddrPaeseId
    AddrProvinciaId
    AddrProvincia
    AddrComuneId
    AddrComune
    AddrIndirizzo
    AddrN
    AddrCap
    CreatedOn
    ModifiedOn
    CreatedBy
    ModifiedBy
    MeteringSlotId
  }
}`;
export const query_aziende_byCfPIva = `
query getAziendeByCfPiva($tenantId: String!, $cf: String!, $pIva: String!) {
  azienda(where: {
    TenantId: {_eq: $tenantId}, Cf: {_ilike: $cf}, PIva:{_ilike: $pIva}
    }) {
    Id
    TenantId
    Denominazione
    Cf
    PIva
    AddrPaeseId
    AddrProvinciaId
    AddrProvincia
    AddrComuneId
    AddrComune
    AddrIndirizzo
    AddrN
    AddrCap
    CreatedOn
    ModifiedOn
    CreatedBy
    ModifiedBy
    MeteringSlotId
  }
}`;
export const query_aziende_byNameCfPIva = `
query getAziendeByCfPiva($tenantId: String!, $denominazione: String!, $cf: String!, $pIva: String!) {
  azienda(where: {
    TenantId: {_eq: $tenantId}, Denominazione: {_ilike: $denominazione}, Cf: {_ilike: $cf}, PIva:{_ilike: $pIva}
    }) {
    Id
    TenantId
    Denominazione
    Cf
    PIva
    AddrPaeseId
    AddrProvinciaId
    AddrProvincia
    AddrComuneId
    AddrComune
    AddrIndirizzo
    AddrN
    AddrCap
    CreatedOn
    ModifiedOn
    CreatedBy
    ModifiedBy
    MeteringSlotId
  }
}`;
export const query_get_allAziende = `
query getAllAziende ($tenantId: String!) {
  getAllAziende (tenantId: $tenantId) {
    id
    tenantId
    denominazione
    cf
    pIva
    addrPaeseId
    addrProvinciaId
    addrProvincia
    addrComuneId
    addrComune
    addrIndirizzo
    addrN
    addrCap
    createdOn
    modifiedOn
    createdBy
    modifiedBy
    meteringSlotId
  }
}`;
export const query_aziendaAddress_primaIdentificazione_byCf = `
query getPrimaIdentificazioneByCf($cf: String!, $tenantId: String!) {
  anagrafica(
    where: {
      Cf: {_eq: $cf},
      TenantId: {_eq: $tenantId},
      IsDeleted: {_eq: false},
      IdentifiedByUser: {_is_null: false, _neq: ""}
    },
    order_by: [{IdentifiedOn: asc_nulls_last}, {CreatedOn: asc}],
    limit: 1
  ) {
    Id
    IdentifiedByUser
    IdentifiedOn
    anagrafica_fascicolos(order_by: {fascicolo: {CreatedOn: asc}}, limit: 1) {
      FascicoloId
      fascicolo {
        Id
        AziendaId
        azienda {
          Id
          Denominazione
          AddrPaeseId
          AddrProvinciaId
          AddrProvincia
          AddrComuneId
          AddrComune
          AddrIndirizzo
          AddrN
          AddrCap
        }
      }
    }
  }
}`;
export const query_getAziendaById = `
query getAziendaById ($id: Int!, $tenantId: String!) {
  getAziendaById (id: $id, tenantId: $tenantId) {
    id
    tenantId
    denominazione
    cf
    pIva
    addrPaeseId
    addrProvinciaId
    addrProvincia
    addrComuneId
    addrComune
    addrIndirizzo
    addrN
    addrCap
    createdOn
    modifiedOn
    createdBy
    modifiedBy
    meteringSlotId
  }
}`;